// PrivacyPolicy.jsx
import React, { useEffect, useState } from 'react';
import {  Modal, Form, Input,  Switch, Select } from 'antd';

import { BreathAPIs } from '../../APIs/BreathAPIs';
import { toast } from 'react-toastify';
import { ButtonCustom } from '../../BootstrapComponents/ButtonCustom';
import styles from './styles.module.css';
import { useSelector } from 'react-redux';

const EditUserWallet = ({ modalVisible, closeModal, selUser, submitFeedback }) => {
    const handleCancel = () => {
        closeModal();
    };
    const [isSubmitting, setIsSubmitting] = useState(false);
    const adminUser = useSelector((state)=>state.auth.user)
    const { Option } = Select;
    const [form] = Form.useForm();

    const userSubmit = async (values) => {

        try {
            setIsSubmitting(true);
            values.user = selUser._id;
            values.adminID = adminUser._id;
            values.adminType = adminUser.type;
            const res = await BreathAPIs.updateWallet(values);
            form.resetFields();
            submitFeedback(res?.data?.message);
            setIsSubmitting(false);
            closeModal();

        } catch (error) {
            toast.error('Error adding user.');
            setIsSubmitting(false);
        }

    };

    useEffect(() => {
        if (selUser) {
            form.resetFields();
        }
    }, [selUser])

    return (
        <Modal
            title="User Wallet"
            open={modalVisible}
            onCancel={handleCancel}
            footer={null}
            width={window.innerWidth <= 768 ? "100%" : "50%"}
        >
            <Form form={form} onFinish={userSubmit} layout={'vertical'}>
                {/* Render form fields for user data */}
                <div className={styles['edit-wallet-top']}>
                    <div>User: <b>{selUser?.firstName}</b></div>
                    <div>Wallet: <b>{selUser?.wallet?.coins?.toFixed(2)}</b></div>
                </div>
                <Form.Item name={'type'} label="Type" rules={[{ required: true, message: "Please select a type" }]}>
                    <Select >
                        <Option value="Credit">Credit</Option>
                        <Option value="Debit">Debit</Option>
                    </Select>
                </Form.Item>

                <Form.Item name={'particular'} label="Particular" >
                    <Input name='Particular' />
                </Form.Item>

                <Form.Item name={'amount'} label="Amount" rules={[{ required: true, message: "Please enter an amount" }]} >
                    <Input type='number' name='Amount' />
                </Form.Item>

                <div className="col-md-12">
                    <Form.Item style={{ textAlign: 'right' }}>
                        <ButtonCustom  isLoading={isSubmitting} text={isSubmitting ? 'Updating...' : 'Update Wallet'} type='submit' />
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    );
};

export default EditUserWallet;
